import { Component, computed, inject, input, output } from '@angular/core';
import { tap } from 'rxjs';
import { Department } from 'src/app/features/department/department.model';
import { DepartmentService } from 'src/app/shared/services/department.service';
import { SnackbarService } from 'ok-angular-shared/components';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorMessage } from 'src/app/shared/models/errorMessage.model';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { EditDepartmentState } from '../create-organization-wizard.component';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'adm-step2-departments',
  templateUrl: './step2-departments.component.html',
  styleUrl: './step2-departments.component.scss',
  imports: [MatTableModule, MatIconModule, MatButtonModule, MatTooltipModule],
})
export class Step2DepartmentsComponent {
  private departmentService = inject(DepartmentService);
  private snackbarService = inject(SnackbarService);
  private dialog = inject(MatDialog);

  newDepartmentId = input.required<number>();
  highlightDepartmentId: number = 0;
  departments = input<Department[]>([]);
  dataSource = computed(() => this.departments());

  editDepartmentIdEvent = output<EditDepartmentState>();
  updateDepartments = output<void>();

  private $newDepartmentId = toObservable(this.newDepartmentId)
    .pipe(
      tap((newDepartmentId: number) => {
        if (newDepartmentId) {
          this.highlightDepartmentId = newDepartmentId;

          setTimeout(() => {
            this.highlightDepartmentId = 0;
          }, 1500);
        }
      }),
      takeUntilDestroyed()
    )
    .subscribe();

  public displayColumns = ['departmentName', 'group', 'address', 'accountNumber', 'agreementNumber', 'actions'];

  editDepartment(department: Department) {
    this.editDepartmentIdEvent.emit({ id: department.departmentId, timestamp: Date.now() });
  }
  deleteDepartment(department: Department) {
    const confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: `Slet afdeling?`,
        text: `Er du sikker på du vil slette afdelingen '${department.departmentName}'?`,
        confirmText: `Ja`,
        denyText: `Nej`,
      },
      disableClose: true,
    });

    confirmDialogRef.afterClosed().subscribe(doDelete => {
      if (doDelete) {
        this.departmentService.deleteDepartment(department.departmentId).subscribe({
          next: () => {
            this.updateDepartments.emit();
            this.snackbarService.success('Afdelingen blev succesfuldt slettet.');
          },
          error: (err: HttpErrorResponse) => {
            const error = err.error as ErrorMessage;
            if (error.code === 100159) {
              this.snackbarService.warning('Afdeling kunne ikke slettes da den har lokationer.');
            } else if (error.code === 100167) {
              this.snackbarService.warning('Afdeling kunne ikke slettes da den har aktive brikker tilknyttet.');
            } else if (error.code === 100168) {
              this.snackbarService.warning('Afdeling kunne ikke slettes da den har bruger(e) med aktive brikker tilknyttet.');
            }
          },
        });
      }
    });
  }
}
